export const LIST_TYPES = {
  DYNAMIC: 'DYNAMIC',
  STATIC: 'STATIC'
};